import React from 'react';
import {
    BarElement,
    CategoryScale,
    Chart as ChartJS,
    Legend,
    LinearScale,
    Title,
    Tooltip
} from 'chart.js';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

export default function RMultipleChart({ data }) {
    const labels = ['1R', '2R', '3R', '4R', '5R', '6R'];

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Percentage of Trades Reaching Level',
                data: labels.map((label) => data[label]?.percentage || 0),
                backgroundColor: [
                    'rgba(82, 196, 26, 0.8)', // 1R - green
                    'rgba(24, 144, 255, 0.8)', // 2R - blue
                    'rgba(114, 46, 209, 0.8)', // 3R - purple
                    'rgba(250, 173, 20, 0.8)', // 4R - gold
                    'rgba(255, 77, 79, 0.8)', // 5R - red
                    'rgba(47, 84, 235, 0.8)' // 6R - royal blue
                ],
                borderColor: [
                    'rgb(82, 196, 26)',
                    'rgb(24, 144, 255)',
                    'rgb(114, 46, 209)',
                    'rgb(250, 173, 20)',
                    'rgb(255, 77, 79)',
                    'rgb(47, 84, 235)'
                ],
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false
            },
            tooltip: {
                callbacks: {
                    label: (context) => `${context.parsed.y.toFixed(1)}% of trades`
                }
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: 100,
                ticks: {
                    callback: (value) => `${value}%`
                }
            }
        }
    };

    return (
        <div className="r-multiple-chart" style={{ height: 300 }}>
            <Bar data={chartData} options={options} />
        </div>
    );
}

RMultipleChart.propTypes = {
    data: PropTypes.objectOf(
        PropTypes.shape({
            percentage: PropTypes.number,
            reached: PropTypes.number
        })
    ).isRequired
};
